// This is just an example,
// so you can safely delete all default props below

export default {
    back: 'Tilbake',
    title: 'Roller',
    create: 'Opprett',
    search_by_name: 'Søk på navn',
    name: 'Navn',
    claims: 'Krav',
}